import { render, staticRenderFns } from "./needOrderList.vue?vue&type=template&id=36b2fcfb&scoped=true&"
import script from "./needOrderList.vue?vue&type=script&lang=js&"
export * from "./needOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2fcfb",
  null
  
)

export default component.exports